import React, { useMemo } from 'react'
import { IFaxCoversheet } from '@dataTypes/fax.type'
import {
  parseCoversheetContent,
  renderCoversheetToHtml,
} from '@utils/fax-coversheet.util'
import { sanitizeEmailHtml } from '@utils/sanitize-html.util'

type Props = {
  template: IFaxCoversheet
}

const DEFAULT_TO = 'Recipient name'
const DEFAULT_FAX = '(555) 000-0000'
const DEFAULT_FROM = 'Clinic'
const DEFAULT_TITLE = 'Cover sheet'

const FaxCoversheetThumbPreview: React.FC<Props> = ({ template }) => {
  const html = useMemo(() => {
    const content = parseCoversheetContent(template.content)
    if (!content) return null
    return sanitizeEmailHtml(
      renderCoversheetToHtml({
        ...content,
        title: content.title || template.file_name || DEFAULT_TITLE,
        to: {
          ...content.to,
          recipientName: content.to?.recipientName || DEFAULT_TO,
          recipientFax: content.to?.recipientFax || DEFAULT_FAX,
        },
        from: {
          ...content.from,
          displayName: content.from?.displayName || DEFAULT_FROM,
          faxNumber: content.from?.faxNumber || DEFAULT_FAX,
        },
      }),
    )
  }, [template])

  if (template.thumbnail_url) {
    return (
      <img
        className="fax-template-thumb fax-template-thumb-image"
        src={template.thumbnail_url}
        alt=""
      />
    )
  }

  if (!html) {
    return <div className="fax-template-thumb" />
  }

  return (
    <div className="fax-template-thumb fax-template-thumb-preview">
      <div
        className="fax-template-thumb-scale"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  )
}

export default FaxCoversheetThumbPreview
